import {
  SingleProviderConfig,
  ShopType,
  CheckoutType,
  CrossSellType,
} from 'types';
import {
  allLeadMode,
  getDefaultCrossSellAction,
  providerRedirectUrl,
} from 'config';
import { BrightspeedTheme } from 'config/themes';
import {
  ATT,
  Brightspeed,
  BrightspeedV2,
  CenturyLink,
  QuantumFiber,
  Frontier,
  Windstream,
  CincinnatiBell,
  Verizon,
  Comcast,
  Cox,
  Spectrum,
  Mediacom,
  Optimum,
  Wave,
  Grande,
  RCN,
  WOW,
  TDS,
  BuckeyeBroadband,
  FidiumFiber,
  //Earthlink,
} from 'config/providers';

export const BrightspeedSpecial: SingleProviderConfig = {
  name: 'BrightspeedSpecial',
  micrositeCode: 'Brightspeed',
  mainProvider: BrightspeedV2,
  shopType: ShopType.SINGLE_PROVIDER,
  domain: 'brightspeedspecial.com',
  homepage: 'https://brightspeedspecial.com',
  title: 'Brightspeed Authorized Dealer',
  fallbackPhoneNumber: '877-782-3529',
  fallbackLeadModePhoneNumber: '800-972-9908',
  defaultCheckoutType: CheckoutType.PROVIDER_REDIRECT,
  defaultTheme: BrightspeedTheme,
  needsDcSession: false,
  source: 'BrightspeedV2',
  noOffersRetry: 2,
  getCrossSellAction: getDefaultCrossSellAction,
  getCheckoutType: allLeadMode,
  getProviderRedirectUrl: providerRedirectUrl,
  providerRedirectFeatureFlag: 'provider_app_brightspeed_linkout_offers',
  crossSellProviders: [
    Verizon,
    ATT,
    Brightspeed,
    CenturyLink,
    QuantumFiber,
    Frontier,
    Windstream,
    CincinnatiBell,
    //Earthlink,
  ],
  updaterCrossSellActive: true,
  updaterCrossSellProviders: [
    Comcast,
    Cox,
    Spectrum,
    Mediacom,
    Optimum,
    Wave,
    Grande,
    RCN,
    WOW,
    TDS,
    BuckeyeBroadband,
    FidiumFiber,
  ],
};
